"use client"
import * as React from "react"
import { LoginForm, type LoginFormValues } from "@workspace/ui/components/own/login-form"

export default function Page() {
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState("")

    async function handleLogin(values: LoginFormValues) {
        setLoading(true)
        setError("")

        try {
            const res = await fetch("/api/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(values),
            })

            if (!res.ok) {
                const data = await res.json()
                setError(data.error || "Login failed")
                return
            }

            window.location.href = "/dashboard"
        } finally {
            setLoading(false)
        }
    }

    return (
        <LoginForm
            onSubmit={handleLogin}
            loading={loading}
            errorMessage={error}
            registrationHref="/registrieren"
            forgotPasswordHref="/forgot-password"
        />
    )
}
